import { getISODay, isSameDay, isValid, isWithinInterval, toDate } from 'date-fns';
import type { SiteHoliday } from '@/services/rental-api-client';
import type { IsDateHolidayParams } from './types';

function isSingleDay(holiday: SiteHoliday): boolean {
    return Boolean(isSameDay(holiday.startDateTime, holiday.endDateTime));
}

function hasStartAndEnd(holiday: SiteHoliday): boolean {
    return isValid(toDate(holiday.startDateTime)) && isValid(toDate(holiday.endDateTime));
}

function hasDow(holiday: SiteHoliday): holiday is SiteHoliday & { dow: number } {
    return holiday.dow !== undefined;
}

export function isHolidayForDate({ holiday, date }: IsDateHolidayParams): boolean {
    if (isSingleDay(holiday) && isSameDay(holiday.startDateTime, date)) {
        return true;
    } else if (hasStartAndEnd(holiday) && hasDow(holiday) && getISODay(date) === holiday.dow && isWithinInterval(date, { start: holiday.startDateTime, end: holiday.endDateTime })) {
        return true;
    } else if (!hasStartAndEnd(holiday) && hasDow(holiday) && getISODay(date) === holiday.dow) {
        return true;
    } else if (hasStartAndEnd(holiday) && !hasDow(holiday) && isSingleDay(holiday) && isSameDay(date, holiday.startDateTime)) {
        return true;
    } else if (
        hasStartAndEnd(holiday) &&
        !hasDow(holiday) &&
        isWithinInterval(date, {
            start: holiday.startDateTime,
            end: holiday.endDateTime,
        })
    ) {
        return true;
    }
    return false;
}
